// 현재 면담에는 위기 대응 과제가 없습니다. 위기 사례일 때만 해당 데이터를 전달합니다.
export const crisisFeedback = { requiresResponse: false };
